import React, { Component } from "react";
import styled from "styled-components";
import theme from "ui/styles/theme";
import withDocuments from "containers/withDocuments";
import { StaggeredMotion, spring } from "react-motion";
import { Row, Col, media } from "styled-bootstrap-grid";
import IconDownload from "ui/components/generic/IconDownload";
import easing from "ui/styles/easing";
import { toPlainText } from "../../../../utils/PlainText";

class Results extends Component {
  static defaultProps = {
    documentType: null,
    product: null,
    search: null,
    language: null,
  };

  state = {
    sortBy: "documentType",
    reverse: false,
  };

  returnString(needle, haystack) {
    if (haystack) {
      const result = haystack.find((straw) => straw.slug === needle);

      return result ? result.title : "";
    } else {
      return needle;
    }
  }

  getDefaultStyles() {
    const documents = this.props.documents.nodes;

    let styles = [];

    if (documents.length > 20) {
      documents.map(() => {
        return styles.push({ o: 1, t: 0 });
      });
    } else {
      documents.map(() => {
        return styles.push({ o: 0, t: 50 });
      });
    }

    return styles;
  }

  sortDocuments = (sortBy) => {
    const sortedDocuments = this.props.documents.nodes;
    const reverse = sortBy
      ? this.state.sortBy === sortBy && !this.state.reverse
      : false;

    if (!sortBy) {
      sortBy = "documentType";
    }

    if (reverse && !this.state.reverse) {
      sortedDocuments.sort((a, b) => b[sortBy].localeCompare(a[sortBy]));
    } else sortedDocuments.sort((a, b) => a[sortBy].localeCompare(b[sortBy]));

    this.setState({ sortBy, reverse });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.documents !== this.props.documents && this.props.documents) {
      this.sortDocuments();
    }
  }

  render() {
    const {
      documentTypes,
      languages,
      products,
      showAllDocuments,
      filterActive,
      documentsLoading,
    } = this.props;

    const documents = this.props.documents ? this.props.documents.nodes : [];

    const { sortBy, reverse } = this.state;

    return (
      <Wrapper key={documents.length}>
        {showAllDocuments || filterActive ? (
          <div>
            <Header>
              <HeaderCol
                sm={4}
                onClick={() => this.sortDocuments("title")}
                active={sortBy === "title"}
                reverse={reverse}
              >
                <Text style={{ paddingLeft: "1em" }}>
                  Title
                  <SortIndicator />
                </Text>
              </HeaderCol>
              <HeaderCol
                sm={3}
                onClick={() => this.sortDocuments("documentType")}
                active={sortBy === "documentType"}
                reverse={reverse}
              >
                <Text>
                  Type
                  <SortIndicator />
                </Text>
              </HeaderCol>
              <HeaderCol
                sm={2}
                onClick={() => this.sortDocuments("language")}
                active={sortBy === "language"}
                reverse={reverse}
              >
                <Text>
                  Language
                  <SortIndicator />
                </Text>
              </HeaderCol>
              <HeaderCol
                sm={3}
                onClick={() => this.sortDocuments("product")}
                active={sortBy === "product"}
                reverse={reverse}
              >
                <Text>
                  Product
                  <SortIndicator />
                </Text>
              </HeaderCol>
            </Header>

            {documents.length ? (
              <StaggeredMotion
                defaultStyles={this.getDefaultStyles()}
                styles={(prevInterpolatedStyles) =>
                  prevInterpolatedStyles.map((_, i) => {
                    return i === 0
                      ? { o: spring(1), t: spring(0) }
                      : {
                          o: spring(prevInterpolatedStyles[i - 1].o),
                          t: spring(prevInterpolatedStyles[i - 1].t),
                        };
                  })
                }
              >
                {(interpolatingStyles) => (
                  <Alternating>
                    {interpolatingStyles.map((style, i) => {
                      return (
                        <Result
                          href={
                            documents[i].file && documents[i].file.sourceUrl
                          }
                          target="_blank"
                          key={i}
                          style={{
                            opacity: style.o,
                            transform: `translateY(${style.t}px)`,
                          }}
                        >
                          <Row alignItems="center">
                            <Col sm={4}>
                              <Text>{toPlainText(documents[i].title)}</Text>
                            </Col>
                            <Col sm={3}>
                              <Text>
                                {documents[i].documentType
                                  ? this.returnString(
                                      documents[i].documentType,
                                      documentTypes
                                    )
                                  : ""}
                              </Text>
                            </Col>
                            <Col sm={2}>
                              <Text>
                                {documents[i].language
                                  ? this.returnString(
                                      documents[i].language,
                                      languages
                                    )
                                  : ""}
                              </Text>
                            </Col>
                            <Col sm={2}>
                              <Text>
                                {documents[i].product
                                  ? this.returnString(
                                      documents[i].product,
                                      products
                                    )
                                  : ""}
                              </Text>
                            </Col>
                            <Col
                              sm={1}
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              <IconDownload />
                            </Col>
                          </Row>
                        </Result>
                      );
                    })}
                  </Alternating>
                )}
              </StaggeredMotion>
            ) : documentsLoading ? (
              ""
            ) : (
              <NoResults>No documents found</NoResults>
            )}
          </div>
        ) : (
          ""
        )}
      </Wrapper>
    );
  }
}

export default withDocuments((props) => ({
  documentType: props.documentType,
  product: props.product,
  search: props.search,
  language: props.language,
}))(Results);

// Styles
const Wrapper = styled.div``;

const Alternating = styled.div`
  > a:nth-child(odd) {
    background: ${theme.colors.tones.lighter};
  }
`;

const Text = styled.div`
  font-size: 14px;
  color: ${theme.colors.tones.dark};
  width: 100%;
  margin-bottom: 0.25em;

  ${media.sm`
    margin: 0;
  `}
`;

const Result = styled.a`
  text-decoration: none;
  color: inherit;
  padding: 20px 10px;
  display: block;
  transition: background-color 0.3s ${easing.easeOutCubic};

  ${Text} {
    transition: color 0.3s ${easing.easeOutCubic};
  }

  .anim-stroke {
    transition: stroke 0.3s ${easing.easeOutCubic};
  }

  .anim-fill {
    transition: fill 0.3s ${easing.easeOutCubic};
  }

  &:hover {
    background-color: ${theme.colors.primary} !important;

    ${Text} {
      color: white;
    }

    .anim-stroke {
      stroke: white;
    }

    .anim-fill {
      fill: white;
    }
  }
`;

const Header = styled(Row)`
  font-weight: 500;
  display: none;
  padding: 20px 0;
  text-transform: uppercase;
  margin-top: 20px;

  ${media.sm`
    display: flex;
  `}
`;

const SortIndicator = styled.div`
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid ${theme.colors.tones.dark};
`;

const HeaderCol = styled(Col)`
  ${Text} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid ${theme.colors.tones.dark};
    width: 100%;
    padding: 20px 0 40px;
    opacity: ${(props) => (props.active ? 1 : 0.5)};
    transition: opacity 0.3s ${easing.easeOutCubic};
  }

  &:hover {
    cursor: pointer;

    ${Text} {
      opacity: 1;
    }
  }

  ${SortIndicator} {
    opacity: ${(props) => (props.active ? 1 : 0)};
    transform: ${(props) =>
      props.reverse && props.active ? "rotate(180deg)" : "rotate(0deg)"};
    transition: opacity 0.3s ${easing.easeOutCubic},
      transform 0.3s ${easing.easeOutCubic};
  }
`;

const NoResults = styled.h2`
  font-size: 20px;
  text-transform: uppercase;
  margin: 40px;
  text-align: center;
`;



// WEBPACK FOOTER //
// ./src/ui/components/modules/DocumentSearch/Results.js